import React                            from 'react';
import classNames                       from 'classnames';
import { Observe }                      from 'rewire-core';
import { Theme, WithStyle }             from 'rewire-ui';
import Paper                            from '@material-ui/core/Paper';
import Typography                       from '@material-ui/core/Typography';
import Loader                           from '../ui/Loader';
import RowSelectionGrid                 from '../ui/RowSelectionGrid';
import BatchSummaryToolbar              from './BatchSummaryToolbar';
import batchSummaryModel                from './BatchSummaryModel';
import batchTimecardSummaryModel        from './BatchTimecardSummaryModel';
import { withStyles }                   from '../utility/styles';

const styles = (_theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    position: 'relative',
    flex: 1,
  },
  paperContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  top: {
    flex: 1,
  },
  bottom: {
    flex: 3,
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    flex: 1,
  },
  buttonDiv: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    flex: '0 0 auto',
    flexWrap: 'wrap',
    margin: '0px !important',
  },
  batchGrid: {
    marginBottom: '16px',
  },
  grid: {
    '& table': {
      marginBottom: '0 !important',
    },
    '& th': {
      whiteSpace: 'pre-wrap',
      paddingTop: '3px',
      paddingBottom: '3px',
    },
    '& tr.groupRow td, & tr.groupRow p, & tr.groupRow td.selected': {
      backgroundColor: 'rgb(138, 192, 206)',
      fontWeight: 'bold',
    },
    '& tr.totalRow td, & tr.totalRow p, & tr.totalRow td.selected': {
      color: 'darkslategray',
      backgroundColor: '#cbebcb',
      fontWeight: 'bold',
      fontSize: '1.2em',
    },
    '& .cellContainer': {
      height: 'auto',
    }
  },
  noResults: {
    fontStyle: 'italic',
    margin: '10px',
    flex: 1,
  },
});

interface IBatchSummaryProps {
  className?: string;
}

type BatchSummaryProps = WithStyle<ReturnType<typeof styles>, IBatchSummaryProps>;

class BatchSummaryView extends React.PureComponent<BatchSummaryProps> {
  constructor(props: BatchSummaryProps) {
    super(props);
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <div className={`${classes.paperContainer} ${classes.top}`}>
            <BatchSummaryToolbar />

            <Observe render={() => {
              return batchSummaryModel.searchResultsMessage
                       ? <Typography variant='h5' className={classes.noResults}>{batchSummaryModel.searchResultsMessage}</Typography>
                       : null;
            }} />

            <Observe>{() => (
              <>
                <Loader loading={batchSummaryModel.isLoading}>
                  <Paper className={classNames(classes.paper, classes.batchGrid)} elevation={4}>
                    <Observe render={() => (
                      <RowSelectionGrid className={classes.grid} grid={batchSummaryModel.grid} />
                    )} />
                  </Paper>
                </Loader>
              </>
            )}</Observe>
          </div>

          <div className={`${classes.paperContainer} ${classes.bottom}`}>
            <Observe>{() => (
              <>
                <Loader loading={batchTimecardSummaryModel.isLoading}>
                  <Paper className={classes.paper} elevation={4}>
                    <Observe render={() => (
                      <RowSelectionGrid className={classes.grid} grid={batchTimecardSummaryModel.grid} />
                    )} />
                  </Paper>
                </Loader>

                <Observe render={() => {
                  return batchTimecardSummaryModel.searchResultsMessage
                      ? <Typography variant='h5' className={classes.noResults}>{batchTimecardSummaryModel.searchResultsMessage}</Typography>
                      : null;
                }} />
              </>
          )}</Observe>
          </div>
      </div>
    );
  }
}

export default withStyles<IBatchSummaryProps>(styles, BatchSummaryView);
